import { forwardRef, useEffect, useRef } from 'react';
import {
  type TextareaAPI as BaseTextareaAPI,
  type TextareaProps as BaseTextareaProps,
  Textarea as BaseTextarea,
} from '@ets/design-system';
import cn from 'classnames';

import styles from './styles.module.scss';

export type TextareaAPI = BaseTextareaAPI;
export type TextareaProps = BaseTextareaProps & {
  variant?: 'default' | 'compact';
  shouldFocus?: boolean;
  noColor?: boolean;
};

export const Textarea = forwardRef<TextareaAPI, TextareaProps>(
  ({ variant = 'default', shouldFocus, noColor, ...props }, ref) => {
    const internalRef = useRef<HTMLTextAreaElement | null>(null);

    const setRefs = (el: TextareaAPI | null) => {
      internalRef.current = el as HTMLTextAreaElement | null;
      if (typeof ref === 'function') {
        ref(el);
      } else if (ref) {
        ref.current = el;
      }
    };

    useEffect(() => {
      if (shouldFocus && internalRef.current) {
        internalRef.current.focus();
      }
    }, [shouldFocus]);

    return (
      <BaseTextarea
        {...props}
        className={cn({
          [styles.compact]: variant === 'compact',
          [styles.stretched]: props.unstyled,
          [styles.default]: noColor,
        })}
        ref={setRefs}
      />
    );
  },
);
